import { Component } from '@angular/core'

@Component({
  selector: 'lin-layout-section-toolbar',
  templateUrl: './section-toolbar.component.html',
  standalone: false,
})
export class SectionToolbarComponent {}
